export const sectors = [
  'State & Federal Government Offices',
  'Hospitals & Medical Facilities',
  'Courthouses & Justice Facilities',
  'Commercial Offices & Campuses',
  'Retail & Restaurants',
  'Educational Institutions',
  'High-Rise Residential',
];
